import { Stack } from '@mui/material';

import { Typography } from '@ocx/ui';
import { IReceiptOption } from '@ocx-app/modules/transaction/types';

type OptionItemProps = {
  option: IReceiptOption;
};

export const OptionItem = ({ option }: OptionItemProps) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="body1">{option.title}</Typography>
      <Stack direction="row" alignItems="center" spacing={1}>
        {option.icon}
        {option.value && (
          <Typography variant="body1" color="textSecondary">
            {option.value}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
